import { clientFetch, Uri } from '../utils/fetch';
import { hotelOnlyModel, hotelOnlyPriceMatrix } from '../models/hotelOnly';

export const fetchHotelOnlyHotels = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;
  const query = {
    ...hotelOnlyModel,
    userId,
    siteId,
  };

  const uri = new Uri({ domain: apiUrl, path: '/api/hotelOnly/hotels', query });
  const response = await clientFetch.getJsonByProxy(uri, baseUrl);

  return response;
};

export const fetchHotelOnlyPriceMatrix = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;

  const query = {
    siteId,
    userId,
    ...hotelOnlyPriceMatrix,
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/hotelOnly/room-matrix',
    query,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};

export const addHotelOnlyToCart = async (model, siteSettings) => {
  const { apiUrl, baseUrl } = siteSettings;

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/hotelOnly/addToCart',
    query: model,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);

  return response;
};
